import { getUrl, Post, Get, Put, Patch, Upload } from '.'

export const SearchQrVa = async body => {
  return Post(getUrl('cnps.css.va-qr.search'), body)
}

export const SearchQr = async body => {
  return Post(getUrl('cnps.css.user-qr.search'), body)
}

export const Search = async body => {
  return Post(getUrl('cnps.css.merchant-account.search'), body)
}

export const List = async body => {
  return Post(getUrl('cnps.css.merchant-account.get-by-type-assign'), body)
}

// export const DetailStickerVa = async (id) => {
//   return Post(getUrl('cnps.css.va-qr.detail',), {id:id})
// }

export const SearchMCSME = async body => {
  return Post(getUrl('cnps.dfs.mc-sme.filter'), body)
}

// body: { "ids": string[] }
// export const GetListByIds = async (body) => {
//   return Post(getUrl('cnps.css.merchant-account.get-list'), body);
// }

export const GetCount = async body => {
  return Post(getUrl('cnps.css.merchant-account.count-by-type-assign-status'), body)
}

export const Create = async body => {
  return Post(getUrl('cnps.css.merchant-account.create'), body)
}

export const Detail = async id => {
  return Get(getUrl('cnps.css.merchant-account.get', { id }))
}

export const Update = async (id, body) => {
  return Put(getUrl('cnps.css.merchant-account.update', { id }), body)
}

export const UpdateStatus = async (id, body) => {
  return Patch(getUrl('cnps.css.merchant-account.update-status', { id }), body)
}

export const ChangeQrStatus = async body => {
  return Put(getUrl('cnps.css.user-qr.change-status'), body)
}
export const DetailSticker = async id => {
  return Get(getUrl('cnps.css.user-qr.get', { id }))
}
export const DetailStickerVa = async id => {
  return Post(getUrl('cnps.css.va-qr.detail'), { id: id })
}

export const UpdateSticker = async body => {
  return Put(getUrl('cnps.css.user-qr.upload-image-web'), body)
}

/**
 * Download qr code of merchant account
 * @param {import('./types').IDownloadQrBody} body: { customerId: string, ids: string[] }
 * @return {Promise<import('axios').AxiosResponse<Blob>>}
 */
export const RequestCreateQrVa = async body => {
  return Post(
    getUrl('cnps.css.va-qr.request-create-va-qr'),
    body.request,
    body.responseType && {
      responseType: 'blob',
    }
  )
}

// export const RequestCreateQrVa = async (body) => {
//   return Post(getUrl(''), body);
// }

/**
 * Download qr code of merchant account
 * @param {import('./types').IDownloadQrBody} body: { customerId: string, ids: string[] }
 * @return {Promise<import('axios').AxiosResponse<Blob>>}
 */
export const DownloadQr = async body => {
  return Post(getUrl('cnps.css.user-qr.print-qr'), body, {
    responseType: 'blob',
  })
}

/**
 * Download qr code of merchant account
 * @param {import('./types').IDownloadQrBody} body: { customerId: string, ids: string[] }
 * @return {Promise<import('axios').AxiosResponse<Blob>>}
 */
export const DownloadQrVa = async body => {
  return Post(getUrl('cnps.css.va-qr.print'), body, {
    responseType: 'blob',
  })
}

/**
 * Get list id of merchant account by list customer id
 * @param {string[]} ids: list customer id
 * @return {Promise<import('axios').AxiosResponse<{ data: { [customerId: string]: string } }>>}
 */
export const GetIdsByCustomerIds = async ids => {
  return Post(getUrl('cnps.css.merchant-account.get-list-id-by-customer-id'), { ids })
}

export const UploadFileAssignStaff = async (formData, callback) => {
  return Upload(getUrl('cnps.css.assign-order.import-file-ma'), formData, callback)
}
